module.exports = __webpack_public_path__ + "static/media/care-at-excel2.7f60976a.jpg";